import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import LiterarySidebar from '../Literaryclub2023/components/LiterarySidebar';
import Sidebar2026 from '../Literaryclub2023/components/Sidebar2026';

const Englishcca2class2026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2026}/home/events-activities/association/LitreryClub/Englishcca2class/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/association/LitreryClub/Englishcca2class/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/association/LitreryClub/Englishcca2class/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/association/LitreryClub/Englishcca2class/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/association/LitreryClub/Englishcca2class/5.webp`;
    const p6 = `${config.base_image_url_2026}/home/events-activities/association/LitreryClub/Englishcca2class/6.webp`;

  
    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        }, 
        {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
        },
    ];

    return (
        <Main>

            <Container>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
                                <Typography variant='h5' align='center' >
                               Topic: Story Telling with A Twist   
                                </Typography>
                                         <br/>

                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Class: 2   Date:  24 June 2026
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                "Love nature and be kind to animals"

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
The final round of English CCA Storytelling <strong>with A Twist Competition</strong> was conducted on 25 July 2026. 
Young storytellers embarked on a magical journey where imagination knew no bounds and every word painted a beautiful picture.
                                <br></br>
Armed with a set of<strong> given words and characters,</strong> the children spun enchanting tales that sparkled with creativity, laughter,
 adventure and heartfelt emotions. From brave heroes and clever animals to magical forests and unexpected twists, each story 
 unfolded like a colourful rainbow, captivating the hearts of everyone present.
With radiant smiles and confident voices, the participants brought their characters to life through expressive narration 
and vivid imagination. Their stories blossomed into delightful adventures, proving that even a handful of words can bloom into extraordinary tales when nurtured by a creative mind.
                                <br></br>
Our respected Principal applauded the young storytellers for their remarkable imagination, confidence and expressive narration.
 The Principal appreciated the enthusiasm with which every child transformed the given words and characters into delightful tales, 
 proving that creativity blossoms when nurtured with encouragement and opportunity.
The judges admired the children's originality, fluent expression, and seamless use of the given words and characters.
 Every participant was applauded for their enthusiasm and courage, making the competition a true celebration of imagination and the art of storytelling.                 
               <br></br>
               The event concluded on a joyful note, while every child was appreciated for adding a unique splash of colour to this literary celebration. The competition left behind cherished memories, 
               inspired budding storytellers and reminded everyone that every child holds a world of stories waiting to be shared.
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
“Stories are the wings that help young minds soar beyond imagination."
                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>

                        
                        <Box marginBottom={4}>
                            <Sidebar2026/>
                        </Box>
                        {/* <Box marginBottom={4}>
                                    <Archive2023/>
                        </Box> */}
                        <Box marginBottom={4}>
                                    <LiterarySidebar/>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Main>


    );
};

export default Englishcca2class2026;